var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Day',{attrs:{"day":"03.12.2017"}},[_c('div',{attrs:{"slot":"page-content"},slot:"page-content"},[_c('h3',[_vm._v("...und ich wollt Dir nur mal sagen:")]),_c('br'),_c('h2',[_vm._v(" Ich find Dich ziemlich süß! ")]),_c('hr'),_c('Gallery',{attrs:{"directory":"2017/03"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }